import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { Field, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';

let MeasurementsAverageSectionBase: React.FC<IWorksheetComponent> = (): JSX.Element => {
  return (
    <ListFieldSection heading="Average">
      <Field input={<TextOutput />} name="AverageCorrectedBulkDensity" />
    </ListFieldSection>
  );
};

const MeasurementsAverageSection = withInjectedProps(MeasurementsAverageSectionBase);
export { MeasurementsAverageSection };
